import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c87d207"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex" }

import { onMounted, computed, watch } from "vue";
// import { useStore } from "vuex";
import { useRoute } from 'vue-router'
import QuestionDetail from "@/components/question/QuestionDetail.vue";
import { QuestionDetailLogic } from "@/logic/question/QuestionDetailLogic";
import { QuestionFavoriteLogic } from "@/logic/question/QuestionFavoriteLogic";
import { QuestionCategoryLogic } from "@/logic/question/QuestionCategoryLogic";
import { QusitionState } from "@/state/QusitionState";
import { ElMessage } from "element-plus"
// import { useStore } from 'vuex'
// const store = useStore();

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const { loadQuestion, detailQuestionLoading, detailIineLoading,
  updateQuestion, deleteQuestion, iine, cancelIine, sendComment, updateComment, deleteComment,
  moveQuestionCategory, detailCommentLoading, user_views, loadViewUsers
} = QuestionDetailLogic();
const { favorite, cancelFavorite } = QuestionFavoriteLogic();
const { loadQuestionCategories, questionCategoryErrors } = QuestionCategoryLogic();
const question = computed(() => QusitionState.state.question);
const questionCategories = computed(() => QusitionState.state.questionCategories);
watch(questionCategoryErrors, () => {
  if (questionCategoryErrors.value == "") {
    return;
  }
  ElMessage({
    showClose: true,
    message: questionCategoryErrors.value,
    type: 'error'
  });
  questionCategoryErrors.value = "";
})

onMounted(async (): Promise<void> => {
  QusitionState.setProjectId(Number(route.params.project_id));
  loadQuestionCategories();
  loadQuestion(Number(route.params.question_id))
})

return (_ctx: any,_cache: any) => {
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, { class: "main" }, {
      default: _withCtx(() => [
        _createVNode(QuestionDetail, {
          question: _unref(question),
          detailLoading: _unref(detailQuestionLoading),
          iineLoading: _unref(detailIineLoading),
          commentLoading: _unref(detailCommentLoading),
          questionCategories: _unref(questionCategories),
          user_views: _unref(user_views),
          onUpdateQuestion: _unref(updateQuestion),
          onDeleteQuestion: _unref(deleteQuestion),
          onIine: _unref(iine),
          onCancelIine: _unref(cancelIine),
          onFavorite: _unref(favorite),
          onCancelFavorite: _unref(cancelFavorite),
          onSendComment: _unref(sendComment),
          onUpdateComment: _unref(updateComment),
          onMoveQuestionCategory: _unref(moveQuestionCategory),
          onDeleteComment: _unref(deleteComment),
          onLoadViewUsers: _unref(loadViewUsers)
        }, null, 8, ["question", "detailLoading", "iineLoading", "commentLoading", "questionCategories", "user_views", "onUpdateQuestion", "onDeleteQuestion", "onIine", "onCancelIine", "onFavorite", "onCancelFavorite", "onSendComment", "onUpdateComment", "onMoveQuestionCategory", "onDeleteComment", "onLoadViewUsers"])
      ]),
      _: 1
    })
  ]))
}
}

})